import * as React from "react";

function SvgViewEyeFocusIcon(props) {
  return (
    <svg
      data-name="Componente 54 \u2013 1"
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      {...props}
    >
      <defs>
        <clipPath id="viewEyeFocusIcon_svg__a">
          <path
            data-name="Ret\xE2ngulo 430"
            transform="translate(737 241)"
            fill="#2e3c50"
            stroke="#2e3c50"
            d="M0 0h18v18H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Grupo 2663">
        <g data-name="Grupo 2662" transform="translate(14802 -11200)">
          <rect
            data-name="Ret\xE2ngulo 1448"
            width={32}
            height={32}
            rx={5}
            transform="translate(-14802 11200)"
            fill="#def4ee"
          />
          <g
            data-name="Grupo de m\xE1scara 79"
            transform="translate(-15532 10966)"
            clipPath="url(#viewEyeFocusIcon_svg__a)"
          >
            <g data-name="view (2)">
              <g data-name="Grupo 647">
                <g data-name="Grupo 646">
                  <path
                    data-name="Caminho 306"
                    d="M754.331 250.254c-.151-.195-3.743-4.755-8.331-4.755s-8.179 4.56-8.33 4.754a.5.5 0 000 .618c.151.194 3.743 4.754 8.33 4.754s8.18-4.559 8.33-4.753a.5.5 0 00.001-.618zm-8.33 4.324c-3.379 0-6.306-3.026-7.172-4.015.865-.99 3.786-4.015 7.172-4.015s6.306 3.026 7.172 4.015c-.865.99-3.786 4.015-7.173 4.015z"
                    fill="#008560"
                    stroke="#008560"
                    strokeWidth={0.5}
                  />
                </g>
              </g>
              <g data-name="Grupo 649">
                <g data-name="Grupo 648">
                  <path
                    data-name="Caminho 307"
                    d="M746.005 247.002a3.56 3.56 0 103.56 3.56 3.565 3.565 0 00-3.56-3.56zm0 5.934a2.374 2.374 0 112.369-2.369 2.376 2.376 0 01-2.369 2.369z"
                    fill="#008560"
                    stroke="#008560"
                    strokeWidth={0.5}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgViewEyeFocusIcon;

